import React from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import Panel from './Panel';
import { IconForecast } from './icons';

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="tooltip">
      <div className="tooltip__h">{label}</div>
      <div className="tooltip__v">{payload[0].value.toLocaleString('fr-FR')}</div>
    </div>
  );
}

/** Courbe de prévision de flux sur 24 h (aire dégradée émeraude). */
export default function PredictionsChart({ data, delay = 0 }) {
  const points = data?.predictions || [];
  const zone = data?.zone_id || '—';
  const peak = points.reduce((m, p) => (p.flux_prevu > m.flux_prevu ? p : m), points[0] || { flux_prevu: 0, heure: '—' });

  return (
    <Panel
      icon={IconForecast}
      title="Prévision de flux · 24 h"
      sub={`Zone ${zone} · ${data?.modele || 'modèle'}`}
      badge={`pic ${peak?.flux_prevu?.toLocaleString('fr-FR')} à ${peak?.heure}`}
      delay={delay}
    >
      <div className="chart-wrap">
        <ResponsiveContainer width="100%" height={230}>
          <AreaChart data={points} margin={{ top: 8, right: 8, left: -14, bottom: 0 }}>
            <defs>
              <linearGradient id="fluxFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#10b981" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#0d9488" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#eef2f6" vertical={false} />
            <XAxis
              dataKey="heure" tickLine={false} axisLine={false}
              interval={3} tick={{ fontSize: 11 }} dy={6}
            />
            <YAxis tickLine={false} axisLine={false} width={46} tick={{ fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} cursor={{ stroke: '#0d9488', strokeWidth: 1, strokeDasharray: '4 4' }} />
            <Area
              type="monotone" dataKey="flux_prevu"
              stroke="#0d9488" strokeWidth={2.4}
              fill="url(#fluxFill)" dot={false}
              activeDot={{ r: 5, fill: '#0d9488', stroke: '#fff', strokeWidth: 2 }}
              animationDuration={900}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Panel>
  );
}
